import { s as script } from './Field-64a63988.mjs';
export { s as OField } from './Field-64a63988.mjs';
import { b as registerComponent } from './plugins-0d853d1f.mjs';
import 'vue';
import './MatchMediaMixin-d91585a4.mjs';
import './config.mjs';
import './helpers.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export { index as default };
